const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPkiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.89 36.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.2,17.25V3.54A.77.77,0,0,1,3,2.77H38.18a.78.78,0,0,1,.77.77V36.46a.78.78,0,0,1-.77.77H3a.77.77,0,0,1-.76-.77V23.9",
    transform: "translate(-0.05 -1.77)",
    style: {
      fill: "none",
      stroke: "#004a80",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66,17.11a5.48,5.48,0,0,1-.95,3.53,3.84,3.84,0,0,1-3.06,1.15H12.21v5.48H9.59V12.47h4a3.82,3.82,0,0,1,3.13,1.15A5.5,5.5,0,0,1,17.66,17.11Zm-2.63,0a3.46,3.46,0,0,0-.33-1.73,1.27,1.27,0,0,0-1.17-.56H12.21v4.6H13.5a1.25,1.25,0,0,0,1.17-.57A3.47,3.47,0,0,0,15,17.11Z",
    transform: "translate(-0.05 -1.77)",
    style: {
      fill: "#0174c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.49,23.91v3.36H18.9V12.47h2.59v7l3.15-7h2.64l-3.06,6.12,3.56,8.68H25l-2.25-5.74Z",
    transform: "translate(-0.05 -1.77)",
    style: {
      fill: "#0174c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.44,12.47v14.8H28.85V12.47Z",
    transform: "translate(-0.05 -1.77)",
    style: {
      fill: "#0174c3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.3,
    cy: 21.36,
    r: 2.3,
    style: {
      fill: "#004a80"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkiIcon);
export default __webpack_public_path__ + "static/media/pkiIcon.63a1c1dfb0f7ab65d2266445ea0174eb.svg";
export { ForwardRef as ReactComponent };